/*
BOLD-OPTIONS-V2-CALCULATED-FIELDS.JS

A plugin for Product Options (V2) that allows you to set up calculations to relate two or more options to each other.
Also allows using any field in the form (including variant field and quantity field) as either an input or target for a calculation

To set up a calculation, run the following command, where calcObj is a calculation object:

new BOLD.calculated_options.Calculation(calcObj)

Format of a calculation object:

  inputs: An array of objects specifying the input fields used for the calculation, using:
    name: Internal Name (AKA System Name) for the option
    alias: (Optional) Name to be passed into the formula with the option values. If not supplied, name will be used instead. (If no name, ID will be used to identify the option)
    id: (Optional) ID of the option to be used. If not supplied, value passed for name will be used instead
    is_form_field: (Optional) If true, uses the name to search for the field in the entire product form (for using fields not generated via Options)

  target_id: (Optional) ID of the option to receive the calculated value. If not supplied, target_name will be used instead
  target_name: Internal Name of the option that will receive the calculated value
  target_is_form_field: (Optional) If true, looks in the form for the field (not in Options)

  quantity: If true, writes calculated value to the corresponding quantity box for the option
  parent_value: (Optional) If set, will pass this value to the target option to make sure the quantity box appears. (Default: 'checked')

  formula: A function whose return value will be written to the target field.  An object containing key-value pairs based on the inputs will be passed into this function, where the keys are the aliases for all the specified inputs

*/




  //Set up the namespace
  window.BOLD = BOLD || {};
  BOLD.calculated_options = {
    single_template: "\u003cdiv class=\"bold_option calculated_qty_option bold_option_{{ optionType }} {{#optionValueNoStock}}bold_option_out_of_stock{{\/optionValueNoStock}} \" \u003e\n  {{#optionTitle}}\n  \u003cspan class=\"bold_option_title\"\u003e\n    {{{ optionTitle }}}\n    {{#maxSizeDiv}}\n    {{{ maxSizeDiv }}}\n    {{\/maxSizeDiv}}\n  \u003c\/span\u003e\n  {{\/optionTitle}}\n\n  {{#optionElement}}\n  \u003cspan class=\"bold_option_element bold_hidden\" style=\"display:none\"\u003e{{{ optionElement }}} {{{ optionValuePrice }}}\u003c\/span\u003e\n  {{\/optionElement}}\n\n  {{#optionQuantity}}\n  \u003cspan\u003e{{{ optionQuantity }}}\u003c\/span\u003e\n  {{\/optionQuantity}}\n\n  {{#optionValueNoStock}}\n  \u003cspan class=\"bold_out_of_stock_message\"\u003e\n    \u003csmall\u003e{{ outOfStockMessage }}\u003c\/small\u003e\n  \u003c\/span\u003e\n  {{\/optionValueNoStock}}\n\n  {{#helpText}}\n  \u003cspan class=\"bold_help_text\"\u003e\n    \u003csmall\u003e{{{ helpText }}}\u003c\/small\u003e\n  \u003c\/span\u003e\n  {{\/helpText}}\n\u003c\/div\u003e",

    CalcObj: function(input_obj){
      if(typeof input_obj != 'object'){
        Object.setPrototypeOf(this, null);
        return false;
      }
      this.inputs = [];
      for(var i=0; i<input_obj.inputs.length; i++){
        var input = input_obj.inputs[i];
        if(!input) continue;
        var calcInput = (input instanceof BOLD.calculated_options.CalcField ? input : new BOLD.calculated_options.CalcField(input.name, input.id, input.alias, input.is_form_field));
        this.inputs.push(calcInput);
        this.has_mock_options = this.has_mock_options || input.is_form_field;
      }

      this.target = new BOLD.calculated_options.CalcField(input_obj.target_name, input_obj.target_id, input_obj.target_alias, input_obj.target_is_form_field);
      this.has_mock_options = this.has_mock_options || input_obj.target_is_form_field;

      this.formula = (typeof input_obj.formula === 'function' ? input_obj.formula : null);
      this.edits_quantity = input_obj.quantity || false;
      if(this.edits_quantity){
        this.parent_value = input_obj.parent_value || 'checked';
      }
    },

    CalcField: function(name, id, alias, is_mock_option){
      this.name = (typeof name === 'string' ? name : null);
      this.id = (typeof id === 'string' ? id : null);
      this.alias = (alias && typeof alias === 'string' ? alias : null);
      this.is_mock_option = is_mock_option;

      if(!name && !id){
        console.warn('BOLD CALCULATED OPTIONS: Meaningless input data provided. Expected (name, [id], [alias]) but received', arguments);
        Object.setPrototypeOf(this, null);
        return false;
      }

      this.matches = function(str){
        return str == this.name.toUpperCase() || str == this.id;
      };

    },

    mock_options:{},

    MockOption: function(inputName, keyword, optionProduct, calculation){
      var mockOption = this;
      var form = optionProduct.form;
      if(!form){
        console.warn('BOLD CALCULATED OPTIONS: Could not create option: No form associated with supplied OptionProduct', arguments);
        Object.setPrototypeOf(this, null);
        return false;
      }
      this.type = 'shopify';
      this.minitype = 'xx';
      this.internalName = keyword || inputName;
      this.option_product = optionProduct;
      this.calculation = calculation;
      this.inputName = inputName;
      this.inputs = form.querySelectorAll('[name="' + this.inputName + '"]');
      this.isMulti = (this.inputs.length > 1 ? true : false);
      this.getInputs = function(){ return this.inputs; };

      if(this.isMulti){
        this.type += 'multi';
        this.minitype += 'm';
      }

      this.triggerCalc = function(evt){
        mockOption.calculation.runCalculation(mockOption.option_product);
      };

      this.getInputs = function(){
        return this.inputs;
      }

      for(var i=0; i<this.inputs.length; i++){
        var input = this.inputs[i];
        if(typeof input.addEventListener === 'function'){
          input.removeEventListener('change', this.triggerCalc);
          input.addEventListener('change', this.triggerCalc);
        }
      }

      this.getValueArray = function(){
        var variant = this.option_product.priceHandler.currentVariant || {};
        var variantOptions = variant.options.reduce(function(acc, val, index){ acc[val] = variant['option' + index]; return acc; }, {});
        var form = this.option_product.form;
        var valuesArr = [];
        var qtyBox = BOLD.calculated_options.getOptionQuantityBox(this.option_product, this);
        if(qtyBox.length){
          qtyBox = qtyBox[qtyBox.length-1];
        }
        for(var i=0; i<this.inputs.length; i++){
          valuesArr.push({
            app:BOLD.options.app,
            id:this.option_product.productId,
            name:input.value,
            option:this,
            outOfStock:variant.available,
            price:variant.price || 0,
            productHandle:variant.product_handle,
            productId:this.option_product.productId,
            qty: qtyBox.value,
            quantityMode:"EDITABLE",
            selected:false,
            swatch:undefined,
            variantId:variant.id,
            variant:variant
          });
        }
        return valuesArr;
      };

      this.getSelectedValues = this.getValueArray;

      this.receiveValue = function(value){

        if(typeof value=== 'object' && value.length != this.inputs.length){
          console.warn('BOLD CALCULATED OPTIONS: Cannot apply option values for ' + this.internalName, value);
          return false;
        }

        for(var i=0; i<this.inputs.length; i++){
          var receive_value = (typeof value === 'object' ? (value.length == this.inputs.length ? value[i] : this.inputs[i].value) : (value));
          if(this.inputs[i].value != receive_value){
            this.inputs[i].value = receive_value;
            BOLD.helpers.dom.trigger('change', this.inputs[i]);
          }
        }
      }

      BOLD.calculated_options.mock_options[optionProduct.productId] = BOLD.calculated_options.mock_options[optionProduct.productId] || [];
      BOLD.calculated_options.mock_options[optionProduct.productId].push(this);
    },

    setupMockOptions:function(calculation, option_product){
      if(!calculation || !option_product){
        return;
      }

      if(calculation.settings.has_mock_options && !BOLD.calculated_options.mock_options[option_product.productId]){
        var target = calculation.settings.target
        if(target.is_mock_option){
          new BOLD.calculated_options.MockOption(target.name, target.alias || target.name, option_product, calculation);
        }

        var inputs = calculation.settings.inputs;
        for(var i=0; i<inputs.length; i++){
          var input = inputs[i];
          if(input.is_mock_option){
            new BOLD.calculated_options.MockOption(input.name, input.alias || input.name, option_product, calculation);
          }
        }
      }
    },

    Calculation: function(calc_obj){
      var calculation = this;
      if(!(calc_obj instanceof BOLD.calculated_options.CalcObj)){
        calc_obj = new BOLD.calculated_options.CalcObj(calc_obj);
      }
      this.settings = calc_obj;

      //console.log("assigned this.settings");
      //window.thisSettings = this.settings;

      if(!(this.settings instanceof BOLD.calculated_options.CalcObj)){
        console.warn('BOLD CALCULATED OPTIONS: Attempted to create a calculated option with an invalid object:', calc_obj);
        Object.setPrototypeOf(this, null);
        return false;
      }

      if(!BOLD.options || !BOLD.options.app || !BOLD.options.app.on){
        console.warn('BOLD CALCULATED OPTIONS: Failed to create a calculation set because BOLD.options is not loaded yet.');
        Object.setPrototypeOf(this, null);
        return false;
      }

      if(!calc_obj.formula || !(calc_obj.target)){
        console.warn('BOLD CALCULATED OPTIONS: Supplied calculation produces no output:', calc_obj);
        Object.setPrototypeOf(this, null);
        return false;
      }

      if(!calc_obj.inputs.length){
        console.warn('BOLD CALCULATED OPTIONS: Supplied calculation has no input fields and will never trigger:', calc_obj);
        Object.setPrototypeOf(this, null);
        return false;
      }

      if(!calc_obj.target.is_mock_option ){
        var target = BOLD.calculated_options.getOption(BOLD.options.app.optionProducts[0], calc_obj.target);
        if(target){
          // BOLD.options.setTemplate(target.className, BOLD.calculated_options.single_template);
          var option = BOLD.options.app.optionProducts[0].getOptionByClassName(target.className);
          calc_obj.parent_value && option && option.receiveValue(calc_obj.parent_value);
        }

        BOLD.options.app.on('options_loaded', function(a){
          var target = BOLD.calculated_options.getOption(a.data.option_product, calc_obj.target);
          // BOLD.options.setTemplate(target.className, BOLD.calculated_options.single_template);
          calc_obj.parent_value && a.data.option_product.getOptionByClassName(target.className).receiveValue(calc_obj.parent_value);
        });
      }


      for(var i=0; i < calc_obj.inputs.length; i++){
        var input = BOLD.calculated_options.getOption(BOLD.options.app.optionProducts[0], calc_obj.inputs[i]);
        if(!input){
          continue;
        }
        var inputFields = input.getInputs();
        for(var f=0; f < inputFields.length; f++){
          BOLD.helpers.dom.trigger('change', inputFields[f]);
        }
      }
      BOLD.options.app.on('options_loaded', function(a){
        for(var i=0; i < calc_obj.inputs.length; i++){
          var input = BOLD.calculated_options.getOption(a.data.option_product, calc_obj.inputs[i]);
          if(!input){
            continue;
          }
          var inputFields = input.getInputs();
          for(var f=0; f < inputFields.length; f++){
            BOLD.helpers.dom.trigger('change', inputFields[f]);
          }
        }
      });


      this.onOptionChanged = function(a){
        if(!(a && a.data && a.data.option && a.data.option)){
          console.warn('BOLD CALCULATED OPTIONS: Attempted to run onOptionChanged outside the context of changing an option');
          return false;
        }

        //Set up mock options, if they have not yet been added
        BOLD.calculated_options.setupMockOptions(calculation, a.data.option_product);

        var option = a.data.option;
        var internal_name = option.internalName.toUpperCase();
        var option_id = option.className;

        for(var i=0; i<calculation.settings.inputs.length; i++){
          var input = calculation.settings.inputs[i];
          if(input instanceof BOLD.calculated_options.CalcField && (input.matches(option_id) || input.matches(internal_name)) ){
            return calculation.runCalculation(a.data.option_product);
          }
        }
        return;
      };

      this.onVariantChanged = function(evt){
        for(var i=0; i<BOLD.options.app.optionProducts.length; i++){
          var option_product = BOLD.options.app.optionProducts[i];
          window.option_product = option_product;
          calculation.runCalculation(option_product);
        }
      };

      this.runCalculation = function(option_product){
        if(!option_product){
          console.warn('BOLD CALCULATED OPTIONS: Cannot run calculation with an OptionProduct');
          return;
        }

          //console.log("runCalculation#1");
          //window.option_product = option_product;


        var form = option_product.form;
        if(!form){
          console.warn('BOLD CALCULATED OPTIONS: No form associated with this OptionProduct', option_product);
          return;
        }

        var calcData = {};
        var found_one = false;
        var variant = option_product.priceHandler.currentVariant || {};

        for(var i=0; i<this.settings.inputs.length; i++){
          var inputObj = this.settings.inputs[i];
          var option = BOLD.calculated_options.getOption(option_product, inputObj);

          if(!option && variant.options){
            var product = BOLD.productsById[option_product.productId]
            //Try to see if the variant has the data we are looking for
            var optIndex = product.options.indexOf(inputObj.name);
            if(optIndex > -1){
              option = {type:'variant', getValueArray: function(){ return [variant['option' + (optIndex + 1)]]} }
            }
          }
          if(found_one && !option){
            console.warn('BOLD CALCULATED OPTIONS: Could not complete the calculation as the OptionProduct contained some, but not all, of the specified option inputs:', this.settings.inputs);
          }
          if(!option){
            return;
          }
          found_one = true;

          var valueArr = option.getValueArray();
          var isMulti = (option.type.indexOf('multi') > -1 || option.minitype == 'swm' ? true : false);
          var valueName = inputObj.alias || inputObj.name || option.internalName;
          calcData[valueName] = (isMulti ? valueArr : valueArr[0]);
          if(typeof calcData[valueName] === 'string' && !isNaN(parseFloat(calcData[valueName]))){
            var number_value = parseFloat(calcData[valueName]);
            if(number_value == calcData[valueName]){
              calcData[valueName] = number_value;
            }
          }
          if(typeof calcData[valueName] === 'undefined'){
            calcData[valueName] = null;
          }
        }


        var target_option = BOLD.calculated_options.getOption(option_product, this.settings.target);
        BOLD.calculated_options.setOptionInputFieldsAsReadOnly(target_option);

        var result = this.settings.formula(calcData, target_option, option_product, this);
        if(result === null || typeof result === 'undefined'){
          //Stuff for no result
          return;
        }

        if(this.settings.edits_quantity){
//           target_option.receiveValue(this.settings.parent_value);
          var target_qty_input = BOLD.calculated_options.getOptionQuantityBox(option_product, target_option, this.settings.parent_value);
          if(target_qty_input){
            if(target_qty_input.length){
              for(var q=0; q<target_qty_input.length; q++){
                if(target_qty_input[q].value != result){
                  target_qty_input[q].value = result;
                  target_qty_input[q].setAttribute('readonly', true);
                  BOLD.helpers.dom.trigger('change', target_qty_input[q]);
                }
              }
            }
            else{
              if(target_qty_input && target_qty_input.setAttribute && target_qty_input.value != result){
                target_qty_input.value = result;
                target_qty_input.setAttribute('readonly', true);
                BOLD.helpers.dom.trigger('change', target_qty_input);
              }
            }
          }
        } else {
          if(target_option.minitype == 'dd'){
            var option_element = target_option.DOM.element.querySelector('select');
            option_element && (option_element.value = result);
            if(option_element && !option_element.value){
              option_element.selectedIndex = 0;
            }
            this.triggerChangeOnOption(target_option)
          }

          if( !this.optionValueWillChange(target_option, result) ){
            return;
          }
          target_option.receiveValue(option_element ? option_element.value : result);
          this.triggerChangeOnOption(target_option)

        }


      };

      BOLD.options.app.on('option_changed', this.onOptionChanged, this);
      BOLD.common.eventEmitter.on('BOLD_COMMON_variant_changed', this.onVariantChanged, this);
      return true;
    },
    getOption:function(option_product, inputObj){
      return (inputObj.is_mock_option ? BOLD.calculated_options.getMockOption(option_product, inputObj.name) : BOLD.calculated_options.getOptionById(option_product, inputObj.id) || BOLD.calculated_options.getOptionByInternalName(option_product, inputObj.name));
    },

    getOptionById:function(option_product, id){
      if(!option_product || !id){
        return null;
      }
      return option_product.getOptionByClassName(id);
    },

    getOptionByInternalName:function(option_product, name){
      if(!option_product || !name){
        return null;
      }

      for(var os=0; os<option_product.optionSets.length; os++){
        var optionSet = option_product.optionSets[os];
        for(var o=0; o<optionSet.options.length; o++){
          var option = optionSet.options[o];
          if(option.internalName.toUpperCase() == name.toUpperCase()){
            return option;
          }
        }
      }
    },

    getMockOption:function(option_product, name){
      if(!option_product || !name){
        return null;
      }

      var mock_options = BOLD.calculated_options.mock_options[option_product.productId];
      if(!mock_options){
        return null;
      }
      for(var o=0; o<mock_options.length; o++){
        if(mock_options[o].inputName.toUpperCase() === name.toUpperCase()){
          return mock_options[o];
        }
      }
    },

    getOptionQuantityBox:function(option_product, option, parent_value){
      var form = option_product.form;
      if(option.type == 'shopify' || option.type == 'shopifymulti'){
        return form['quantity'];
      }

      if(option.type.indexOf('multi') > -1 || option.minitype === 'swm'){
        //Loop through all the optionValues to find the one we need based on parent_value
        for(var v=0; v<option.optionValues.length; v++){
          if(option.optionValues[v].name == parent_value){
            return form.getElementsByClassName(BOLD.calculated_options.buildQuantityClass(option, option.optionValues[v]));
          }
        }
        //Not found?
        return null;
      }

      //Single option
      return form.getElementsByClassName(BOLD.calculated_options.buildQuantityClass(option, option.optionValues[0]));
    },

    buildQuantityClass:function(option, optionValue){
      var qty_class = option.className.split('_');
      qty_class[0] = 'qty';
      return qty_class.join('_') + '_' + optionValue.id;
    },

    setOptionInputFieldsAsReadOnly:function(option){
      if(option && typeof option.getInputs === 'function'){
        var inputFields = option.getInputs();
        for(var i=0; i<inputFields.length; i++){
          if(inputFields[i].setAttribute){
            inputFields[i].setAttribute('readonly', true);
          }
        }
      }
    }

  }

  BOLD.calculated_options.Calculation.prototype = {
    createResultArr:function(option, result){
      var currentValues = option.getValueArray();
      var resultArr;

      if(result instanceof Array){
        resultArr = result
      } else {
        resultArr = [result];
      }

      // Text fields can accept any kind of value - we're not restricted to any preset list
      if(option.type.indexOf('text') > -1){
        return resultArr;
      }
      //Only return results that are valid option selections - strip out any weird things that don't belong
      //Empty string is added as a valid value (which is used to clear all current selections);
      var availableValues = [''].concat(option.optionValues.reduce(function(acc, value){ acc.push(value.name); return acc }, []) )
      return resultArr.filter(function(val){ return availableValues.indexOf(val) > -1 })
    },
    optionValueWillChange:function(option, result){
      var resultArr = this.createResultArr(option, result);
      var currentValues = option.getValueArray();

      // If the length of the arrays is not the same, we know an update is needed
      if(resultArr.length !== currentValues.length){
        return true;
      }

      // Return true if any of the values don't match up
      for(var i=0; i<currentValues.length; i++){
        if(currentValues[i].indexOf(resultArr[i]) == -1) {
          return true;
        }
      }
      // No mismatches, nothing will change
      return false;
    },
    triggerChangeOnOption:function(option){
      var change_event_target = option.DOM.element.querySelector('select,input');
      //This fixes instances where clearing the last option from a multi-select list doesn't always remove that last option from memory
      change_event_target && BOLD.helpers.dom.trigger('change', change_event_target);
    }
  }

  // setPrototypeOf Only works in Chrome and FireFox, does not work in IE:
  Object.setPrototypeOf = Object.setPrototypeOf || function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
  }


